export default {
  namespaced: true,
  breadcrumbs: {
    vaas: {
      camera_manager: {
        master_account: 'VaaS > Camera Manager > Master Account',
        reseller: 'VaaS > Camera Manager > Reseller',
        cameras: 'VaaS > Camera Manager > Cameras',
        status_cameras: 'VaaS > Camera Manager > Status Cameras',
      },
      safr: {
        cameras: 'VaaS > SAFR > Cameras',
        master_accounts: 'VaaS > SAFR > Master Accounts',
        access_clearences: 'VaaS > SAFR > Access and Clearences',
      },
      hikvision: {
        master_accounts: 'VaaS > Hikvision > Master Accounts',
        hikvision_dvr: 'VaaS > Hikvision > Hikvision DVR',
        hikvision_cameras: 'VaaS > Hikvision > Hikvision Cameras',
      },
      ee_vms: {
        master_accounts: 'VaaS > EE VMS > Master Accounts',
        accounts: 'VaaS > EE VMS > Accounts',
        bridges: 'VaaS > EE VMS > Bridges',
        cameras: 'VaaS > EE VMS > Cameras',
        presets: 'VaaS > EE VMS > Presets',
      },
      luxriot: {
        master_accounts: 'VaaS > Luxriot > Master Accounts',
        cameras: 'VaaS > Luxriot > Cameras',
      },
      omnicloud: {
        master_accounts: 'VaaS > OmniCloud > Master Accounts',
        cameras: 'VaaS > OmniCloud > Cameras',
        omnia_reseller: 'VaaS > OmniCloud > Omnia Reseller',
      },
      dahua: {
        dahua_dvr: 'VaaS > Dahua > Dahua DVR',
        dahua_cameras: 'VaaS > Dahua > Dahua Cameras',
      },
      hanwha: {
        hanwha_dvr: 'VaaS > Hanwha > Hanwha DVR',
        hanwha_cameras: 'VaaS > Hanwha > Hanwha Cameras',
      },
      generic_devices: 'VaaS > Generic Devices',
      proxy_rtsp_server: 'VaaS > Proxy RTSP Servers',
      recording_requests: {
        tag: 'VaaS > Recording Requests > Tag',
        recording_requests: 'VaaS > Recording Requests > Recording Requests',
      },
      analytics: {
        facial_recognition: {
          sarf: {
            events: 'VaaS > Analytics > Facial Recognition > SAFR > Events',
            groups: 'VaaS > Analytics > Facial Recognition > SAFR > Groups',
            people: 'VaaS > Analytics > Facial Recognition > SAFR > People',
          },
          luna: {
            master_accounts: 'VaaS > Analytics > Facial Recognition > Luna > Master Accounts',
            list: 'VaaS > Analytics > Facial Recognition > Luna > List',
            face: 'VaaS > Analytics > Facial Recognition > Luna > Face',
            facial_recognition_matches: 'VaaS > Analytics > Facial Recognition > Luna > Facial Recognition Matches',
            facestream: 'VaaS > Analytics > Facial Recognition > Luna > FaceStream',
          }
        },
        lpr: {
          plate_list: 'VaaS > Analytics > LPR > Plate List',
          plate: 'VaaS > Analytics > LPR > Plate',
          lpr_matches: 'VaaS > Analytics > LPR > LPR Matches',
        },
        detections_events: 'VaaS > Analytics > Detections Events',
      },
      video_watermarks: 'VaaS > Video Watermarks',
      pacom: {
        master_accounts: 'IoT > Pacom > Master Accounts',
        sites: 'IoT > Pacom > Sites',
        actions: 'IoT > Pacom > Actions',
        schemaTypes: 'vaas > Pacom > Schema Types',
        entries: 'IoT > Pacom > Entries',
        alarms: 'IoT > Pacom > Alarms',
        alarmTypes: 'IoT > Pacom > Alarm types',
        logs: 'IoT > Pacom > Logs'
      }
    },
    tenants: {
      all_tenants: 'Tenants > All Tenants',
      master_tenants: 'Tenants > Master Tenants',
      incident_list: 'Tenants > Incident List',
      incident_chart: 'Tenants > Incident Chart',
      logs_incidents: 'Tenants > Logs Incidents',
      layouts: 'Tenants > Layouts',
      device_tag: 'Tenants > Device Tag',
      token: 'Tenants > Token',
      token_omnitag: 'Tenants > Token Omnitag',
      tenants_storage: 'Tenants > Tenants Storage',
      tenants_storage_files: 'Tenants > Tenants Storage > Tenant Files',
    },
    users: {
      all_users: 'Users > All Users',
      profiles: 'Users > Profiles',
      permissions: 'Users > Permissions',
      groups: 'Users > Groups',
      users_app: 'Users > Users App',
    },
    alarms: {
      all: 'Alarms > All',
      seproban: 'Alarms > Seproban',
      alarms_levels: 'Alarms > Alarms Levels',
      alarm_comment: 'Alarms > Alarm Comment',
      alarm_views: 'Alarms > Alarm Views',
      alarm_purge: 'Alarms > Alarm Purge',
    },
    facilities: {
      all_facilities: 'Facilities > All Facilities',
      centers: 'Facilities > Centers',
      sectors: 'Facilities > Sectors',
      municipalities: 'Facilities > Municipalities',
    },
    logs: {
      system_logs: 'Logs > System Logs',
      traffic: 'Logs > Traffic',
      command_logs: 'Logs > Command Logs',
      action_plan_logs: 'Logs > Action Plan Logs',
    },
    iot: {
      buttons: {
        all_buttons: 'IoT > Buttons > All Buttons',
        button_types: 'IoT > Buttons > Button Types',
      },
      intelbras: {
        master_accounts: 'IoT > Intelbras > Master accounts',
        panels: 'IoT > Intelbras > Panels',
        alarmTypes: 'IoT > Intelbras > Rules',
        alarms: 'IoT > Intelbras > Alarms',
        log: 'IoT > Intelbras > Log',
        rules: 'IoT > Intelbras > Rules',
      },
      dmp: {
        master_accounts: 'IoT > Intelbras > Master accounts',
        panels: 'IoT > Dmp > Panels',
        alarmTypes: 'IoT > Dmp > Rules',
        alarms: 'IoT > Dmp > Alarms',
        log: 'IoT > Dmp > Log',
        rules: 'IoT > Dmp > Rules',
        profiles: 'IoT > Dmp > Profiles',
        servers: 'IoT > Dmp > Servers'
      },
      bosch: {
        panels: 'IoT > Bosch > Panels',
        log: 'IoT > Bosch > Log',
        rules: 'IoT > Bosch > Rules',
        profiles: 'IoT > Bosch > Profiles',
      }
    },
    automation: {
      custom_command: 'Automation > Custom Command',
      workflow: 'Automation > Workflow',
      action_plan: 'Automation > Action Plan',
      document_action_plan: 'Automation > Action Plan Documents',
      schedule_task: 'Automation > Schedule Task',
      alarm_commands: 'Automation > Alarm Commands',
      scripts: 'Automation > Scripts',
    },
    voip: {
      iotcomms_master_accounts: 'VoIP > IoTComms Master Accounts',
      types_devices_interphones: 'VoIP > Types Devices Interphones',
      devices_interphones: 'VoIP > Devices Interphones',
      calls: 'VoIP > Calls',
      omnicloud: {
        master_account: 'VoIP > Omnicloud > Master Accounts',
        devices: 'VoIP > Omnicloud > Devices',
        calls: 'VoIP > Omnicloud > Calls',
      }
    },
    risk: {
      risk_templates: "Risk > Template Forms"
    },
    security_self_audit: {
      templates: "Security Self Audits > Template Forms",
      audits: "Security Self Audits > Audits"
    },
    maintenance: {
      crew: 'Maintenance > Maintenance Crew',
      companies: 'Maintenance > Maintenance Companies',
      templates: 'Maintenance > Maintenance Templates',
      forms: 'Maintenance > Maintenance Forms',
    },
  },
}
